<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.street, 'Stradă')"
      v-model="street"
      :rules="streetValidationRules"
      name="street"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, watch, toRefs} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    addressIndex: Number as () => number | null,
  },
  setup(props, {emit}) {
    const {modelValue, addressIndex} = toRefs(props);
    const street = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      street.value = newValue;
    });

    watch(street, (newValue) => {
      const isValid = validateStreet(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', {field: Number.isInteger(addressIndex.value) ? `street-${addressIndex.value}` : 'street', isValid});
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const streetValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateStreet(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = streetValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return streetValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateStreet(street.value);
      emit('validation-address-status', {field: Number.isInteger(addressIndex.value) ? `street-${addressIndex.value}` : 'street', isValid});

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
      window.addEventListener('validate-house', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === (Number.isInteger(addressIndex.value) ? `street-${addressIndex.value}` : 'street')) {
        const isValid = validateStreet(street.value, true);
        if (isValid) {
          emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `street-${addressIndex.value}` : 'street', isValid });
        }
      }
    };

    return {
      street,
      streetValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>